/**
 * Organization: Revzoom India Pvt Ltd.
 * User: om
 * Date: 29/12/16
 * Time: 11:35 PM
 */
import ErrorId from "./ErrorId";
import HashMap from "./HashMap";
import HashSet from "./HashSet";
import * as ZoomBridge from "./../autogenerated/ZoomBridge";
export default class SerializationUtil {  

  constructor() {
    
  }

  /**
   *
   * @param row{Object}
   * @param key{String}
   * @param array{Array}
   */
  static serializeArray(row, key, array) {
    if (array && array.length > 0) {
      let jsonArray = [];
      for (let i = 0; i < array.length; i++) {
        let item = array[i];
        if (typeof item.serializeJson === 'function') {
          jsonArray.push(item.serializeJson());
        } else {
          jsonArray.push(item);
        }
      }
      row[key] = jsonArray;
    }
  }

  /**
   *
   * @param json
   * @param key
   * @param source
   */
  static serializeSet(json, key, source, useSerializeMethod) {
    if (source && source != null) {
      this.serializeIteratorElements(source.iterator(), json, key);
    }
  }

  /**
   *
   * @param iterator
   * @param json
   * @param key
   */
  static serializeIteratorElements(iterator, json, key) {
    let array = [];
    while (iterator.hasNext()) {
      let next = iterator.next();
      if (typeof next.serializeJson === 'function') {
        array.push(next.serializeJson());
      } else {
        array.push(next);
      }
    }
    json[key] = array;
  }

  /**
   *
   * @param json
   * @param key
   * @param map
   */
  static serializeHashMap(json, key, map) {
    if (map == null) {
      json[key] = [];
      return;
    }

    let mapJSON = [];
    let iterator = map.iterator();
    while (iterator.hasNext()) {
      let next = iterator.next();
      let mapEntry = {
        "key": next.key,
        "value": (next.value && next.value.serializeJson && typeof next.value.serializeJson === 'function') ? next.value.serializeJson() : next.value
      };
      mapJSON.push(mapEntry);
    }
    json[key] = mapJSON;
  }

  /**
   *
   * @param json
   * @param key
   * @param msg
   */
  static serializeEnum(json, key, msg) {
    if (msg == null)
      return;
    if (msg.hasOwnProperty("ordinal")) {
      json.put(key, msg["ordinal"]);
    }
  }

  /**
   *
   * @param responseJSON
   * @param _response
   */
  static deserializeEnum(responseJSON, _response) {
    if (responseJSON != null && responseJSON.hasOwnProperty("ordinal")) {

    }
  }

  /**
   *
   * @param json{Array}
   * @param hashSet
   * @returns {HashSet}
   */
  static deserializeSet(json) {
    let hashSet = new HashSet();
    if (json) {
      for (let i = 0; i < json.length; i++) {
        let item = json[i];
        if (item && item.hasOwnProperty("class")) {
          let classId = item["class"];
          let classSplit = classId.split(".");
          classId = classSplit[classSplit.length - 1];          
          const classObj =  new ZoomBridge[classId]();
          classObj.deserializeJson(item);
          hashSet.add(classObj);
        }
        else {
          hashSet.add(item);
        }
      }
    }
    return hashSet;
  }

  /**
   *
   * @param json
   * @param map {HashMap}
   * @returns {HashMap}
   */
  static deserializeMap(json) {
    let map = new HashMap();

    let array = json ? json : [];
    array.forEach((object) => {
      let key = object.hasOwnProperty("key") ? object["key"] : null;
      let value = object.hasOwnProperty("value") ? object["value"] : null;
      if (value != null && value.hasOwnProperty("class")) {
        let classId = value["class"];
        let classSplit = classId.split(".");
        classId = classSplit[classSplit.length - 1];        
        var classObj = new ZoomBridge[classId]();
        classObj.deserializeJson(value);
        if (classObj) {
          value = classObj;
        }
      }
      map.put(key, value);
    });
    return map;
  }

  /**
   *
   * @param responseJSON
   * @returns {Array}
   */
  static deserializeArray(responseJSON, queryName = null) {
    const zoomBridge = ZoomBridge;
    let array = [];
    if (responseJSON && Array.isArray(responseJSON)) {
      responseJSON.forEach(function(item) {
        const zb=zoomBridge;
        if (typeof item.deserializeJson === 'function') {
          array.push(item.deserializeJson());
        }
        else {
          if (queryName) {
            const object = eval("new zb." + queryName + "()");
            if (object.hasOwnProperty("deserializeJson")) {
              item = object['deserializeJson'](item);
            }
          }
          array.push(item);
        }
      });
    }
    return array;
  }

  /**
   * Checks whether current property has success true or not.
   * @param jsonObject
   * @return {boolean}
   */
  static isSuccess(jsonObject) {
    let rv = false;
    if (jsonObject) {
      if (jsonObject.hasOwnProperty(SerializationUtil.SUCCESS)) {
        rv = jsonObject[SerializationUtil.SUCCESS];
      }
    }
    return rv;
  }

  /**
   *
   * @param jsonObject{*}
   * @returns {boolean}
   */
  static isNotSuccess(jsonObject) {
    return !SerializationUtil.isSuccess(jsonObject);
  }

  /**
   *
   * Method checks for jsonObject's success property  === false,
   * If it is false, then construct an error object by looking for
   * property 'error' or 'message' in json object.
   * @param jsonObject
   * @returns {ErrorId}
   */
  static createErrorIdIfPresent(jsonObject) {
    let errorString = null;
    let errorKey = null;
    if (SerializationUtil.isNotSuccess(jsonObject)) {
      if (jsonObject.hasOwnProperty(SerializationUtil.ERROR)) {
        const errorJsonObject = jsonObject[SerializationUtil.ERROR];
        if (errorJsonObject) {
          errorString = errorJsonObject['message'];
          errorKey =  errorJsonObject['key'];
          if (!errorString) {
            errorString = JSON.stringify(errorJsonObject);
          }
        }
      }
    }
    return errorString ? new ErrorId(-1, errorString) : null;
  }

}

/**
 * @type {string}
 * @private
 */
SerializationUtil.SUCCESS = 'success';
/**
 * @type {string}
 * @private
 */
SerializationUtil.ERROR = 'error';

/**
 * @type {string}
 * @private
 */
SerializationUtil.MESSAGE = 'message';